import { createApp } from './vue';

import HelpCenter from './vue/apps/help-center';

const helpCenterArticleMountingContainer = document.getElementById('js-help-center-article');

if (helpCenterArticleMountingContainer) {
    createApp(HelpCenter).mount(helpCenterArticleMountingContainer);

    const lightbox: HTMLElement | null =
        helpCenterArticleMountingContainer.querySelector('.js-lightbox');
    const btnCloseLightbox = lightbox?.querySelector('.js-close');
    const images = helpCenterArticleMountingContainer.querySelectorAll('img');
    const body = document.body;

    images.forEach((i) => {
        i.addEventListener('click', () => {
            openLightbox(i);
        });
    });

    btnCloseLightbox?.addEventListener('click', () => {
        closeLightbox();
    });

    const closeLightbox = () => {
        lightbox?.classList.remove('is-visible');
        enableBodyScroll();
    };

    const openLightbox = (el: HTMLImageElement) => {
        const imageSrc = el.src.split('?')[0];
        if (lightbox) {
            disableBodyScroll();
            const target: HTMLImageElement | null = lightbox.querySelector('.js-target');
            lightbox?.classList.add('is-visible');

            if (target) {
                target.src = imageSrc;
            }
        }
    };

    const enableBodyScroll = () => {
        body.classList.remove('hide-overflow');
    };

    const disableBodyScroll = () => {
        body.classList.add('hide-overflow');
    };
}
